import { Tabs } from 'antd';
import NewDocumentSimpleTab from "../components/newDocument/NewDocumentSimple";

const NewDocument = () => {
    const items = [
        {
            key: '1',
            label: 'Простое добавление',
            children: <NewDocumentSimpleTab />,
        },
    ];

    return (
        <div className="p-4">
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    );
};

export default NewDocument;
